import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { useCsValue } from "@plansoft-configuration-renderer/framework";
import { DebugColor } from "./DebugColor";
import { useShowDebugValues } from "./DebugOptions";
import { DebugItemPopover } from "./DebugPopover";
import { DebugType } from "./DebugType";
export function CsValueDebug({ chipSx }) {
    const value = useCsValue();
    return _jsx(CsValueDebugDisplay, { value: value, chipSx: chipSx });
}
export function CsValueDebugDisplay({ value, chipSx, }) {
    var _a;
    const showDebug = useShowDebugValues();
    if (!showDebug) {
        return _jsx(Fragment, {});
    }
    return (_jsx(DebugItemPopover, { item: value, color: DebugColor.Value, type: DebugType.Values, title: (_a = value.id) !== null && _a !== void 0 ? _a : value.value, chipSx: chipSx }));
}
//# sourceMappingURL=CsValueDebug.js.map